import { isDefined } from "../is/isDefined.js";
function trimArray(array) {
  return array.filter((item) => {
    return isDefined(item);
  });
}
export {
  trimArray
};
